import { createAction, props } from '@ngrx/store';
import { Logo } from '@core/models';

export const getLogo = createAction(
  '[Logo] Get Logo',
  props<{
    idLogo: number;
  }>()
);

export const getLogoSuccess = createAction(
  '[Logo] Get Logo success',
  props<{
    logo: Logo;
  }>()
);
export const getLogoFailure = createAction(
  '[Logo] Get Logo failure',
  props<{
    error: string;
  }>()
);

export const clearLogo = createAction('[Logo] Clear Logo');
